import styled from 'styled-components';
import { HEADER_HEIGHT } from './StickyHeader';

interface StyledWrapperProps {
  $withStickyFooter: boolean;
}

export const StyledWrapper = styled.div<StyledWrapperProps>`
  display: ${(props) => (props.$withStickyFooter ? 'flex' : 'block')};
  flex-direction: ${(props) => (props.$withStickyFooter ? 'column' : 'row')};
  min-height: ${(props) =>
    props.$withStickyFooter ? `calc(100vh - ${HEADER_HEIGHT})` : 'auto'};
`;
